// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/resources_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message protogen.ResourceLink
 */
export class ResourceLink extends Message<ResourceLink> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string href = 2;
   */
  href = "";

  /**
   * Named icon key resolved to a component on the client (e.g. "video").
   *
   * @generated from field: string icon = 3;
   */
  icon = "";

  /**
   * @generated from field: bool targetNew = 4;
   */
  targetNew = false;

  constructor(data?: PartialMessage<ResourceLink>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ResourceLink";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "href", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "targetNew", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResourceLink {
    return new ResourceLink().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResourceLink {
    return new ResourceLink().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResourceLink {
    return new ResourceLink().fromJsonString(jsonString, options);
  }

  static equals(a: ResourceLink | PlainMessage<ResourceLink> | undefined, b: ResourceLink | PlainMessage<ResourceLink> | undefined): boolean {
    return proto3.util.equals(ResourceLink, a, b);
  }
}

/**
 * @generated from message protogen.ResourceSection
 */
export class ResourceSection extends Message<ResourceSection> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: repeated protogen.ResourceLink links = 3;
   */
  links: ResourceLink[] = [];

  constructor(data?: PartialMessage<ResourceSection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ResourceSection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "links", kind: "message", T: ResourceLink, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResourceSection {
    return new ResourceSection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResourceSection {
    return new ResourceSection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResourceSection {
    return new ResourceSection().fromJsonString(jsonString, options);
  }

  static equals(a: ResourceSection | PlainMessage<ResourceSection> | undefined, b: ResourceSection | PlainMessage<ResourceSection> | undefined): boolean {
    return proto3.util.equals(ResourceSection, a, b);
  }
}

/**
 * A section placed into a specific box of a page's forced grid.
 *
 * @generated from message protogen.PlacedSection
 */
export class PlacedSection extends Message<PlacedSection> {
  /**
   * @generated from field: int32 column = 1;
   */
  column = 0;

  /**
   * @generated from field: int32 row = 2;
   */
  row = 0;

  /**
   * @generated from field: protogen.ResourceSection section = 3;
   */
  section?: ResourceSection;

  constructor(data?: PartialMessage<PlacedSection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.PlacedSection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "column", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "row", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "section", kind: "message", T: ResourceSection },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PlacedSection {
    return new PlacedSection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PlacedSection {
    return new PlacedSection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PlacedSection {
    return new PlacedSection().fromJsonString(jsonString, options);
  }

  static equals(a: PlacedSection | PlainMessage<PlacedSection> | undefined, b: PlacedSection | PlainMessage<PlacedSection> | undefined): boolean {
    return proto3.util.equals(PlacedSection, a, b);
  }
}

/**
 * @generated from message protogen.ResourcePlacementInput
 */
export class ResourcePlacementInput extends Message<ResourcePlacementInput> {
  /**
   * @generated from field: int32 column = 1;
   */
  column = 0;

  /**
   * @generated from field: int32 row = 2;
   */
  row = 0;

  /**
   * @generated from field: string sectionRef = 3;
   */
  sectionRef = "";

  constructor(data?: PartialMessage<ResourcePlacementInput>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ResourcePlacementInput";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "column", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "row", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "sectionRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResourcePlacementInput {
    return new ResourcePlacementInput().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResourcePlacementInput {
    return new ResourcePlacementInput().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResourcePlacementInput {
    return new ResourcePlacementInput().fromJsonString(jsonString, options);
  }

  static equals(a: ResourcePlacementInput | PlainMessage<ResourcePlacementInput> | undefined, b: ResourcePlacementInput | PlainMessage<ResourcePlacementInput> | undefined): boolean {
    return proto3.util.equals(ResourcePlacementInput, a, b);
  }
}

/**
 * @generated from message protogen.ListResourceSectionsRequest
 */
export class ListResourceSectionsRequest extends Message<ListResourceSectionsRequest> {
  constructor(data?: PartialMessage<ListResourceSectionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListResourceSectionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListResourceSectionsRequest {
    return new ListResourceSectionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListResourceSectionsRequest {
    return new ListResourceSectionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListResourceSectionsRequest {
    return new ListResourceSectionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListResourceSectionsRequest | PlainMessage<ListResourceSectionsRequest> | undefined, b: ListResourceSectionsRequest | PlainMessage<ListResourceSectionsRequest> | undefined): boolean {
    return proto3.util.equals(ListResourceSectionsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListResourceSectionsResponse
 */
export class ListResourceSectionsResponse extends Message<ListResourceSectionsResponse> {
  /**
   * @generated from field: repeated protogen.ResourceSection sections = 1;
   */
  sections: ResourceSection[] = [];

  constructor(data?: PartialMessage<ListResourceSectionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListResourceSectionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sections", kind: "message", T: ResourceSection, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListResourceSectionsResponse {
    return new ListResourceSectionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListResourceSectionsResponse {
    return new ListResourceSectionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListResourceSectionsResponse {
    return new ListResourceSectionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListResourceSectionsResponse | PlainMessage<ListResourceSectionsResponse> | undefined, b: ListResourceSectionsResponse | PlainMessage<ListResourceSectionsResponse> | undefined): boolean {
    return proto3.util.equals(ListResourceSectionsResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpsertResourceSectionRequest
 */
export class UpsertResourceSectionRequest extends Message<UpsertResourceSectionRequest> {
  /**
   * Empty ref creates a new section.
   *
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string title = 2;
   */
  title = "";

  /**
   * @generated from field: repeated protogen.ResourceLink links = 3;
   */
  links: ResourceLink[] = [];

  constructor(data?: PartialMessage<UpsertResourceSectionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpsertResourceSectionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "links", kind: "message", T: ResourceLink, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpsertResourceSectionRequest {
    return new UpsertResourceSectionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpsertResourceSectionRequest {
    return new UpsertResourceSectionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpsertResourceSectionRequest {
    return new UpsertResourceSectionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpsertResourceSectionRequest | PlainMessage<UpsertResourceSectionRequest> | undefined, b: UpsertResourceSectionRequest | PlainMessage<UpsertResourceSectionRequest> | undefined): boolean {
    return proto3.util.equals(UpsertResourceSectionRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpsertResourceSectionResponse
 */
export class UpsertResourceSectionResponse extends Message<UpsertResourceSectionResponse> {
  /**
   * @generated from field: protogen.ResourceSection section = 1;
   */
  section?: ResourceSection;

  constructor(data?: PartialMessage<UpsertResourceSectionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpsertResourceSectionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "section", kind: "message", T: ResourceSection },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpsertResourceSectionResponse {
    return new UpsertResourceSectionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpsertResourceSectionResponse {
    return new UpsertResourceSectionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpsertResourceSectionResponse {
    return new UpsertResourceSectionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpsertResourceSectionResponse | PlainMessage<UpsertResourceSectionResponse> | undefined, b: UpsertResourceSectionResponse | PlainMessage<UpsertResourceSectionResponse> | undefined): boolean {
    return proto3.util.equals(UpsertResourceSectionResponse, a, b);
  }
}

/**
 * @generated from message protogen.DeleteResourceSectionRequest
 */
export class DeleteResourceSectionRequest extends Message<DeleteResourceSectionRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  constructor(data?: PartialMessage<DeleteResourceSectionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DeleteResourceSectionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteResourceSectionRequest {
    return new DeleteResourceSectionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteResourceSectionRequest {
    return new DeleteResourceSectionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteResourceSectionRequest {
    return new DeleteResourceSectionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteResourceSectionRequest | PlainMessage<DeleteResourceSectionRequest> | undefined, b: DeleteResourceSectionRequest | PlainMessage<DeleteResourceSectionRequest> | undefined): boolean {
    return proto3.util.equals(DeleteResourceSectionRequest, a, b);
  }
}

/**
 * @generated from message protogen.DeleteResourceSectionResponse
 */
export class DeleteResourceSectionResponse extends Message<DeleteResourceSectionResponse> {
  constructor(data?: PartialMessage<DeleteResourceSectionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.DeleteResourceSectionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteResourceSectionResponse {
    return new DeleteResourceSectionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteResourceSectionResponse {
    return new DeleteResourceSectionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteResourceSectionResponse {
    return new DeleteResourceSectionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteResourceSectionResponse | PlainMessage<DeleteResourceSectionResponse> | undefined, b: DeleteResourceSectionResponse | PlainMessage<DeleteResourceSectionResponse> | undefined): boolean {
    return proto3.util.equals(DeleteResourceSectionResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetResourcePageRequest
 */
export class GetResourcePageRequest extends Message<GetResourcePageRequest> {
  /**
   * "resources" | "help"
   *
   * @generated from field: string page = 1;
   */
  page = "";

  constructor(data?: PartialMessage<GetResourcePageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetResourcePageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetResourcePageRequest {
    return new GetResourcePageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetResourcePageRequest {
    return new GetResourcePageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetResourcePageRequest {
    return new GetResourcePageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetResourcePageRequest | PlainMessage<GetResourcePageRequest> | undefined, b: GetResourcePageRequest | PlainMessage<GetResourcePageRequest> | undefined): boolean {
    return proto3.util.equals(GetResourcePageRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetResourcePageResponse
 */
export class GetResourcePageResponse extends Message<GetResourcePageResponse> {
  /**
   * @generated from field: repeated protogen.PlacedSection placements = 1;
   */
  placements: PlacedSection[] = [];

  constructor(data?: PartialMessage<GetResourcePageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetResourcePageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "placements", kind: "message", T: PlacedSection, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetResourcePageResponse {
    return new GetResourcePageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetResourcePageResponse {
    return new GetResourcePageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetResourcePageResponse {
    return new GetResourcePageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetResourcePageResponse | PlainMessage<GetResourcePageResponse> | undefined, b: GetResourcePageResponse | PlainMessage<GetResourcePageResponse> | undefined): boolean {
    return proto3.util.equals(GetResourcePageResponse, a, b);
  }
}

/**
 * @generated from message protogen.SetResourcePlacementsRequest
 */
export class SetResourcePlacementsRequest extends Message<SetResourcePlacementsRequest> {
  /**
   * @generated from field: string page = 1;
   */
  page = "";

  /**
   * @generated from field: repeated protogen.ResourcePlacementInput placements = 2;
   */
  placements: ResourcePlacementInput[] = [];

  constructor(data?: PartialMessage<SetResourcePlacementsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SetResourcePlacementsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "placements", kind: "message", T: ResourcePlacementInput, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetResourcePlacementsRequest {
    return new SetResourcePlacementsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetResourcePlacementsRequest {
    return new SetResourcePlacementsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetResourcePlacementsRequest {
    return new SetResourcePlacementsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetResourcePlacementsRequest | PlainMessage<SetResourcePlacementsRequest> | undefined, b: SetResourcePlacementsRequest | PlainMessage<SetResourcePlacementsRequest> | undefined): boolean {
    return proto3.util.equals(SetResourcePlacementsRequest, a, b);
  }
}

/**
 * @generated from message protogen.SetResourcePlacementsResponse
 */
export class SetResourcePlacementsResponse extends Message<SetResourcePlacementsResponse> {
  constructor(data?: PartialMessage<SetResourcePlacementsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.SetResourcePlacementsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetResourcePlacementsResponse {
    return new SetResourcePlacementsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetResourcePlacementsResponse {
    return new SetResourcePlacementsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetResourcePlacementsResponse {
    return new SetResourcePlacementsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetResourcePlacementsResponse | PlainMessage<SetResourcePlacementsResponse> | undefined, b: SetResourcePlacementsResponse | PlainMessage<SetResourcePlacementsResponse> | undefined): boolean {
    return proto3.util.equals(SetResourcePlacementsResponse, a, b);
  }
}

